export enum VerActionType {
  PhoneVer = 'PhoneVer',
  EmailVer = 'EmailVer',
  GoogleVer = 'GoogleVer',
}

// 卡片操作项接口
export interface VerActionItem {
  icon: string
  title: string
  description: string
  actionType: VerActionType
}